import {
  LABEL_LIST_TEXT_COLORS,
  LABEL_LIST_TEXT_FONT_SIZE
} from '../../shared/AppConstants';
import { kFormatter } from './helper';
import PropTypes from 'prop-types';

export const CustomLabelList = ({
  activeBarIndex,
  dataset,
  handleBarLabelClick = () => {},
  isDisplay,
  suggestedY,
  ...props
}) => {
  const { height, value, width, x, y } = props;

  if (!isDisplay) {
    return <></>;
  }

  // eslint-disable-next-line no-eq-null, eqeqeq
  const yToUse = suggestedY != null ? suggestedY : y;

  const label = Math.round(value);

  return (
    <g onClick={handleBarLabelClick}>
      <text
        style={{ cursor: 'pointer' }}
        dominantBaseline="middle"
        fill={LABEL_LIST_TEXT_COLORS[dataset]}
        fontSize={LABEL_LIST_TEXT_FONT_SIZE}
        textAnchor="middle"
        x={x + width * 1.3 + String(label).length}
        y={yToUse - height * 3}
      >
        {label > 0 ? kFormatter(label) : `(${kFormatter(Math.abs(label))})`}
      </text>
      <line
        style={{ cursor: 'pointer' }}
        stroke={LABEL_LIST_TEXT_COLORS[dataset]}
        strokeWidth={2}
        x1={x + width}
        x2={x + width + String(label).length + String(label).length / 4 - 2}
        y1={y}
        y2={yToUse - height * 3}
      />
    </g>
  );
};

CustomLabelList.propTypes = {
  activeBarIndex: PropTypes.number.isRequired,
  dataset: PropTypes.string.isRequired,
  handleBarLabelClick: PropTypes.func,
  isDisplay: PropTypes.bool.isRequired,
  suggestedY: PropTypes.number
};
